// import AppLoading from "@/components/ui/loading";
import React, { ReactNode, Suspense } from "react";
import Skeleton from "./ui/skeleton";

const AppSuspense = ({
  children,
}: Readonly<{
  children: ReactNode;
}>) => {
  return (
    <>
      <Suspense fallback={<Skeleton />}>{children}</Suspense>
    </>
  );
};

export default AppSuspense;
